export default __webpack_public_path__ + "static/media/envelope.c21cd6bd.svg";